
import { MainLayout } from '@/layout/MainLayout';
import { AlertPanel } from '@/features/alert-system/components/AlertPanel';

const AlertSystem = () => {
  return (
    <MainLayout>
      <AlertPanel />
    </MainLayout>
  );
};

export default AlertSystem;
